<template>
  <div class="container">
      <h1 class="text-center"> Terms and Conditions</h1>
      <hr>
      <p>
          <strong>Dupaws FZE</strong> (hereafter referred to as “Dupaws”, “Dupaws.com”, “us”, “we” or “our”) is an online platform to connect pet owners with pet sitters who wants to provide housing and care services, the services are offered at Dupaws.com platform (hereafter referred to “website”, “our platform”, “app”,“site”) where pet owners can find, book, communicate and review pet sitters who listed their profiles using our platform.
Anyone who is willing to use Dupaws.com must register an account and accept our terms and conditions, by agreeing to these terms you are legally bound to all the terms listed in this article in addition you agree to our privacy policy rules.
You also understand that we may change the terms from time to time and that these changes can become effective immediately. When we notify our users (“Pet Sitters”, “Pet Owners” and anyone else using Dupaws.com), their continued access and use of Dupaws.com means they are accepting the new terms.
Dupaws.com is intended to be used solely by persons who are 18 years of age or older, by accessing or using any of Dupaws services you agree that you are 18 years old or older, if you are under 18 years old then you are prohibited from using this platform.
</p>

<p>
Dupaws is an online platform which Pet Sitters “Sitters” can create profiles, add their services, setup their service fees and Pet Owners “Clients” can use the platform to find their preferred Sitter, 
Dupaws.com is not a Pet Care Service Facility or Provider, our Platform is used by Pet Sitters to list their services, and to facilitate the communication and interaction between Sitters and Clients, We do not employ any Sitter directly nor do we enforce Clients to use any specific Sitter, it’s the Clients responsibility to validate that the Sitter is the right person to take care of their Pet for the agreed duration or the agreed service, thus we are not liable for any incidents, damages, health or other problems that might occur to Pet Sitter or Pet Owner by using our platform.
</p>
<p>
<h3>Terms</h3>
“Pet Sitter”: is a member who creates a profile and list services he is willing to offer on Dupaws platform.
“Pet Owner”: is a member who has a pet or pets and willing to hire a Pet Sitter for a specific services or multiple services for specific duration.
“Services”: are the Pet Sitter allowed services such as Dog Sitting, Cat Sitting, Dog Walking, Home Sitting etc.
“Platform”: means Dupaws website, mobile app, or any application used by the users to interact and use Dupaws collective services.
“Content”: is any text, graphics, images, music, information, documents, data or other material.
“Third Party”: means any entity that works with Dupaws such as contractors, marketing agencies, distributors, merchants, sponsors, vets or sponsors.
</p>


<h3>Registration:</h3>
<p>
For users to start utilizing Dupaws services they need to be registered, if you decide to use the service and register you agree that you provide accurate and up-to-date information about yourself, your name, address, age and you cannot create more than one account with conflicting information. We keep your credentials (username and password) encrypted and safe in our database.  We will not share your username and password to any third-party entity.
In case you suspect that someone else is using your account you will inform us immediately.
</p>

<h3>Booking Policy:</h3>
<p>Dupaws prohibits booking animals or pets with special needs or requirements such as pets on antibiotics, pets that have severe allergies, dogs or cats who have aggressive behavioral issues, or are very young to be left alone, this is to ensure the safety of the pet and the pet sitter. Also no bookings should take place of breeds or speciies that are banned in the country of the sitter and pet owner, if you need to have boarding for such specific case then our recommendation is to contact your vet or nearby animal shelter and ask them for recommended place to keep your pet.</p>
<p>For stays that are 3 days or longer, we require both the pet sitter and the pet owner to schedule a meet and greet in person to let the pet spend at least 1 day with the sitter on his own to ensure that both are perfect match to each other. pet owners or sitters who don't have the time to take this step are prohibited from booking long stays on Dupaws.com.</p>


<h3>Communication:</h3>
<p>We prohibit users from sharing of their personal emails, phone numbers or any other contact method such as social media account until a booking is accepted by the pet sitter, this is to protect the privacy of all parties. Keep in mind that we might review each message being sent through our platform. Pet Sitters or Pet Owners who fail to follow this can get their account suspended indefinitely.</p>

<!--<h3>Membership:</h3>
<p>Dupaws allows Pet Sitters to join and create their profiles for free 3 months, after this trial subscription period expires they will be prompted to renew their subscription, this free membership will be changed to free 3 booking requests instead of 3 months starting from 13-May-2018, in this case a pet sitter will receive up to 3 booking requests and respond to them, on the 4th request they will be required to renew their subscription to continue, if they decide not to renew then their public profiles will be suspended until renewed. </p>
<p>Pet owners currently have full access to Dupaws services for free, this could change in future with our added value services. </p>

<h3>Payment Policy</h3>
<p>Once a Pet Sitter free trial expires, they will be notified and prompted when they visit Dupaws.com next time to subscribe to 6 months or 1 year access paid membership to continue receiving requests or keeping their profiles online</p>
<p>Dupaws accepts payments from major credit card processing companies such as Mastercard and Visa card. For more information on how Dupaws handle users credit card security please visit our privacy policy page. </p>
-->
<h3>Cancellation/Refund Policy</h3>
<p>All membership plans (Pet owners Membership or Pet sitters Premium accounts) are not refundable, before upgrading your account to paid membership make sure to check if the free basic account addresses your needs.</p>

<h3>Access</h3>
<p>Dupaws has the right under this agreement to limit, suspend or withdraw all your access to Dupaws if deemed necassary to protect Dupaws or it's users from any suspicious activity.</p>

<h3>Liability and Release:</h3>
<p>
You agree that by using Dupaws or any of its services or related services, directly or indirectly release us from any physical or non-physical damage, whether it happened during the booking dates or outside booking dates. 
</p>


<h3>Pets Re-homing:</h3>
<p>
Pet owners who fail to retrieve their pets within seven days after the end of booking dates will be applicable to animal abandonment and cruelty laws, Dupaws or the Pet Sitter will try to contact the pet owner by all feasable means before surrendering the pet to the animal control authorities within their country of booking. Dupaws takes this seriously and will report any such cases to authorities for full investigation.
</p>


<h3>Eligibility:</h3>
<p>By accessing and using Dupaws.com, you acknowledge and confirm that you are at least 18 years of age, if you are offering Pet Sitting or Pet Boarding Services you accept that you comply with your country local laws, you have obtained all the required and necessary licenses, permits needed to operate and offer such activities and that you comply with your country local laws and regulations or permits that might be requested in future by the legal entities.
For Pet owners, your pet needs to be in a healthy state and registered per country's local laws.
We expect all Dupaws users (Pet Sitters, Pet Owners or otherwise to confirm to the local imposed law and by using any of our services we expect that you already complied with the above requirements or other requirements per local regulations).
</p>

<h3>Content:</h3>
<p>We require users who are willing to use our services to upload some information about themselves, their pets, their homes such as images, text descriptions, reviews, opinions, about you or something else that we deem necessary to ensure we are aware of all the needed details to help facilitate the best possible services for our users. By accepting this article you permit Dupaws and/or any of our affiliate partners or third party providers to use, distribute, sublicense or modify this content at Dupaws own discretion, by accepting this you are allowing this content to be publicly shared, displayed, posted, downloaded, reproduced, printed or copied without your permission, any information or data added to Dupaws platform belongs to Dupaws and can be shared on third party sites such as social media or otherwise unless strictly specified by us, such as the combination of your username and password.
You grant Dupaws a non-exclusive, worldwide, perpetual, irrevocable, royalty-free, sub-licensable right to use any information, material, personal or non-personal that was submitted by any means to Dupaws to use for operating, promoting the site, sharing this information with third party entity or otherwise without your consent.
</p>


<h3>Privacy Policy:</h3>
<p>Dupaws takes the privacy of its users seriously, make sure to read all the details in Privacy Policy. </p>

<h3>Indemnity:</h3>
<p>You agree to release Dupaws and its affiliates, officers, employees, agents, suppliers and partners from any claims, demands, actions, proceedings, damages, costs, expenses of any type directly or indirectly whether affected you or someone you know.</p>

<h3>Intellectual Property and copyrights:</h3>
<p>Dupaws provided materials, including but not limited to content such as text, review, feedback, description or software, apps, website, documents, products, logos, graphics, images and services are protected by copyright and trademark laws. None of the materials listed here can be modified or used without official express written permission from Dupaws FZE or any of its affiliate third party licensed partners. You also agree that your feedback or enhancement suggestions regarding any of Dupaws Services can be used without any obligation of compensation. Dupaws owns all rights in and to its trademarks, brand, logos, images and any other service related to us. This also can be a form of goods, toys, business cards, store or anything else that we use as a marketing tool or consumer goods.</p>

<p style="font-weight:600">Updated 12 May 2018</p>
</div>


</template>

<script>
export default {
  name: 'terms' , 
  data() {
    return {
      active:false,
      title:"Dupaws.com Dog Boarding, Cat Sitting and more",
      scrollPosition: ''
    };
  },
  updated(){
     
  },
  mounted(){
  this.$ga.page(this.$router)


  },
  methods: {
   
  },
  
  computed: {
   
     
  },
  head: {
    // To use "this" in the component, it is necessary to return the object through a function
    title: function () {
      return {
        inner: this.title
      }
    },
    meta: [
      { name: 'application-name', content: 'Dupaws.com Pet Sitting' },
      { name: 'description', content: 'Dupaws.com terms and conditions', id: 'desc' },
      { property: 'fb:app_id', content: '279352372578608' },
      { property: 'fb:admins', content:'636428053' },
      { property: 'fb:pages', content:'1623158747696830' },
    ],
     link: [
      { rel: 'canonical', href: 'https://www.dupaws.com/terms-and-conditions', id: 'canonical' },
     ]
  }
  
}

</script>


<style scoped>



</style>


// WEBPACK FOOTER //
// TermsAndConditions.vue?f423b43e